export interface DebtMember {
  user_id?: string
  turn_index?: number
  users?: { full_name?: string; id?: string }
  full_name?: string
  [key: string]: unknown
}

export interface DebtGroup {
  id: string
  name?: string
  current_cycle?: number
  start_date: string
  amount: number
  currency: string
  cycle_period?: string
  group_members?: DebtMember[]
  [key: string]: unknown
}

export interface DebtTransaction {
  group_id: string
  sender_id?: string
  cycle_number: number
  status?: string
  [key: string]: unknown
}

export interface UnpaidDebtItem {
  groupId: string
  groupName: string
  receiverName: string
  amount: number
  currency: string
  dueDate: string
  daysOverdue: number
  currentCycle: number
}

export function calculateUnpaidDebts(params: {
  groups: any[]
  transactions: any[]
  userId: string
  today?: Date
}): UnpaidDebtItem[] {
  const { groups, transactions, userId, today = new Date() } = params
  if (!groups || groups.length === 0 || !userId) return []

  const debts: UnpaidDebtItem[] = []

  for (const g of groups) {
    if (!g) continue
    if (g.status !== 'active') continue
    // Döngü başlamamış grupları atla (kura çekilmemiş → current_cycle=0 veya yok)
    if (!g.current_cycle || g.current_cycle === 0) continue

    const members = g.group_members || []
    // Kullanıcının grup üyeliğini bul
    const myMember = members.find((m: any) => m.user_id === userId)
    if (!myMember) continue

    // Kullanıcı o döngünün alıcısıysa atla
    if (myMember.turn_index === g.current_cycle) continue

    // Bu döngüde ödeme yapmış mı?
    const hasPaid = (transactions || []).some(
      (tx: any) =>
        tx.group_id === g.id &&
        (tx.sender_id === undefined || tx.sender_id === userId) &&
        tx.cycle_number === g.current_cycle
    )
    if (hasPaid) continue

    // Alacaklının adını bul
    const receiverMember = members.find((rm: any) => rm.turn_index === g.current_cycle)
    // B-42: hesapsız sırada profil yok; ad defterden okunur.
    const receiverName =
      receiverMember?.users?.full_name ||
      receiverMember?.display_name ||
      receiverMember?.full_name ||
      'Alacaklı'

    // Gerçek ödeme tarihini hesapla
    const startDate = new Date(g.start_date)
    let actualDueDate: Date
    if (g.cycle_period === 'weekly') {
      actualDueDate = new Date(startDate)
      actualDueDate.setDate(actualDueDate.getDate() + (g.current_cycle - 1) * 7)
    } else if (g.cycle_period === 'biweekly') {
      actualDueDate = new Date(startDate)
      actualDueDate.setDate(actualDueDate.getDate() + (g.current_cycle - 1) * 14)
    } else {
      // monthly (varsayılan)
      actualDueDate = new Date(startDate)
      actualDueDate.setMonth(actualDueDate.getMonth() + (g.current_cycle - 1))
    }

    const dueDateMidnight = new Date(
      actualDueDate.getFullYear(),
      actualDueDate.getMonth(),
      actualDueDate.getDate()
    )
    const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate())
    const daysOverdue = Math.floor(
      (todayMidnight.getTime() - dueDateMidnight.getTime()) / (1000 * 60 * 60 * 24)
    )

    if (daysOverdue > 0) {
      debts.push({
        groupId: g.id,
        groupName: (g.name || '').trim(),
        receiverName,
        amount: g.amount,
        currency: g.currency,
        dueDate: actualDueDate.toISOString().split('T')[0],
        daysOverdue,
        currentCycle: g.current_cycle,
      })
    }
  }

  // Vadesi en çok geçmiş olan önce
  debts.sort((a, b) => b.daysOverdue - a.daysOverdue)
  return debts
}

